import type { GenerateSignedUrl } from '~/api/generated';

export const useUploadStore = defineStore('upload', {
  actions: {
    getSignedUrl({ requestBody }: { requestBody: GenerateSignedUrl }) {
      const apiStore = useApiStore();

      return apiStore.api.upload.uploadCreate({ requestBody });
    },

    uploadFile({ url, body }: { url: string; body: Blob }) {
      const config = useRuntimeConfig();
      const apiStore = useApiStore();

      return fetch(url, {
        method: 'PUT',
        headers: apiStore.apiBase === config.public.apiBase ? { 'x-ms-blob-type': 'BlockBlob' } : undefined,
        body
      });
    },

    getAnonymizationSignedUrl() {
      const apiStore = useApiStore();

      return apiStore.api.upload.uploadAnonymizationSignedUrlCreate();
    },

    uploadAnonymizationFile({ url, body }: { url: string; body: FormData }) {
      return fetch(url, { method: 'POST', body });
    }
  }
});
